import { EventEmitter } from 'events';

const authEventEmitter = new EventEmitter();

export default authEventEmitter;